import React, {Fragment, PureComponent, ReactNode} from 'react'
import {connect} from 'react-redux'
import {TFunction, withTranslation} from 'react-i18next';
import {State} from "@App/state";
import {Organization} from "@App/types";
import {
    OrganizationIsDBConnect,
    OrganizationIsLeaseplan,
    OrganizationIsRepareo
} from "@App/utils/conditionals/organization";

type ContactUsProps = {
    t: TFunction // translation method from withTranslation HOC from i18next
    organization: Organization
    titleHidden?: boolean
    isHome?: boolean
}

const mapStateToProps = (state: State) => ({
    organization: state.orders.organization
})

const orgString = (organization: Organization) => OrganizationIsLeaseplan(organization) ? 'leaseplan' : 'repareo'
const phoneLink = (organization: Organization, t: TFunction) => t(`contact.phone-link-${orgString(organization)}`)
const phone = (organization: Organization, t: TFunction) => t(`contact.phone-${orgString(organization)}`)

export class ContactUsComponent extends PureComponent<ContactUsProps> {

    render(): ReactNode {

        const t = this.props.t
        const organization = this.props.organization
        const titleHidden = this.props.titleHidden
        const isHome = this.props.isHome

        return (
            <div>
                <div className={`footerBlockHeadline text-2xl font-serif text-neutral-700 mb-3 ${titleHidden && 'hidden md:block'}`}>
                    {!titleHidden && t('contact.title')}&nbsp;
                </div>
                <p>{t('contact.text')}</p>
                <div className="flex gap-2 mt-3">
                    <img data-testid="contact-image" className="max-w-[70px] max-h-[70px] md:max-w-[96px] md:max-h-[96px]"
                         src={organization?.settings?.contactDetails?.image  ?? "/images/paulina-rounded.webp"} alt=""/>
                    <table>
                        <tbody className="align-top">
                        <tr>
                            <td className="w-[60px] text-sm md:text-base leading-6">{t('contact.phone')}</td>
                            <td>
                                <a className="text-neutral-700 no-underline" href={phoneLink(organization, t)}>{phone(organization, t)}</a>
                                <br/>
                                <span className={'whitespace-pre-line text-xs lg:text-base'}>{
                                    OrganizationIsRepareo(organization) && t('contact.reachability-repareo')
                                    || OrganizationIsLeaseplan(organization) && t('contact.reachability-leaseplan')
                                    || t('contact.reachability-partner')
                                }</span>
                            </td>
                        </tr>
                        <tr>
                            <td className="w-[60px] text-sm md:text-base leading-6">{t('contact.email')}</td>
                            <td><a className="text-sm md:text-base"
                                   href="mailto:werkstattmeister@repareo.de">werkstattmeister@repareo.de</a></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                {OrganizationIsDBConnect(organization) && isHome && (
                    <Fragment>
                        <p className={'mt-6'}>{t('contact.partner-text', {organization: organization.name})}</p>
                        <div className="flex gap-2 mt-3">
                            <img className="max-w-[70px] max-h-[70px] md:max-w-[96px] md:max-h-[96px]"
                                 src="/images/brand/db.svg" alt=""/>
                            <table>
                                <tbody className="align-center">
                                <tr>
                                    <td className="w-[60px] text-sm md:text-base leading-6">{t('contact.phone')}</td>
                                    <td>
                                        <a className="text-neutral-700 no-underline" href="tel:00496922220332332">+49 69 2222 0332 332</a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </Fragment>
                    )}
            </div>
        )
    }
}

// Connect the component to the Redux store
const ConnectedComponent = connect(mapStateToProps)(ContactUsComponent)
export const ContactUs = withTranslation()(ConnectedComponent)
